export default __webpack_public_path__ + "static/day-8-684bd9988d16806f86c9515e9dc34628.gif";